module.exports = __webpack_public_path__ + "static/media/RELIANCE_LOGO.ccc2cbd5.png";